"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactInstantsearchDom = require("react-instantsearch-dom");
var _generic = _interopRequireDefault(require("../icons/generic"));
var _utils = require("../../utils/utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Packages

// Components

// Utils

// Styles
const {
  above,
  below
} = (0, _utils.getMediaQueries)();
const SearchBoxForm = _styledComponents.default.form.withConfig({
  displayName: "algolia-searchbox__SearchBoxForm",
  componentId: "sc-1n0knu4-0"
})(["padding:14px 0px;transition:0.3s ease-in-out;position:relative;", " &:focus-within{}"], above.mobile`
margin:0 auto;
  max-width:600px;
`);
const SearchBoxInput = _styledComponents.default.input.withConfig({
  displayName: "algolia-searchbox__SearchBoxInput",
  componentId: "sc-1n0knu4-1"
})(["padding-right:64px;width:100%;border-radius:0px;outline:none;border:none;border-bottom:0.5px solid var(--dusky-grey-6-hex);background:var(--ice-grey-1-hex);font-family:\"Playfair Display\";transition:0.3s ease-in-out;font-size:18px;line-height:28px;", " ", " &:focus{border-bottom:2px solid #0b7df4;", "}"], above.mobile`
  font-size: 22px;
line-height: 28px;
`, above.tablet`
width: ${props => props.searchBoxFocus && "600px"};
`, below.mobile`
    border-bottom: 1px solid #0b7df4;
    `);
const SuggestedSearchButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "algolia-searchbox__SuggestedSearchButtonContainer",
  componentId: "sc-1n0knu4-2"
})(["position:relative;.sample-query-button{display:none;background:#e9f1f9;border:none;font-size:14px;line-height:17.6px;padding:4px 12px;margin-right:12px;margin-bottom:8px;cursor:pointer;&:hover{background:var(--pacific-blue-hex);color:white;}&:focus{background:green;}}", ""], above.mobile`
max-width:600px;
margin:0 auto;
`);
const SuggestedSearchButton = _styledComponents.default.button.withConfig({
  displayName: "algolia-searchbox__SuggestedSearchButton",
  componentId: "sc-1n0knu4-3"
})(["background:#e9f1f9;border:none;font-size:14px;line-height:17.6px;padding:4px 12px;margin-right:12px;margin-bottom:8px;cursor:pointer;&:hover{background:var(--pacific-blue-hex);color:white;}"]);
const SearchBoxContainer = _styledComponents.default.div.withConfig({
  displayName: "algolia-searchbox__SearchBoxContainer",
  componentId: "sc-1n0knu4-4"
})(["position:relative;background:var(--ice-grey-1-hex);padding:", ";transition:0.3s ease-in-out;", "{display:", ";}", ""], props => props.searchBoxFocus ? " 64px 0" : "0px 0", SuggestedSearchButton, props => props.searchBoxFocus ? "initial" : "none", above.tablet`
  flex-grow:1;
  margin-left:48px;
  max-width:${props => !props.searchBoxFocus && "440px"};
  `);
const InputContainer = _styledComponents.default.div.withConfig({
  displayName: "algolia-searchbox__InputContainer",
  componentId: "sc-1n0knu4-5"
})(["align-items:center;display:flex;position:relative;img,svg{position:absolute;right:0px;bottom:10px;", "}"], above.mobile`
      bottom:6px;
    `);
// Change submit button to a div since button is non functional with search as you type turned on
const SubmitButton = _styledComponents.default.div.withConfig({
  displayName: "algolia-searchbox__SubmitButton",
  componentId: "sc-1n0knu4-6"
})(["align-self:center;background:none;color:inherit;display:flex;border:none;height:fit-content;padding:0;font:inherit;cursor:initial;outline:inherit;"]);
const ClearButton = _styledComponents.default.button.withConfig({
  displayName: "algolia-searchbox__ClearButton",
  componentId: "sc-1n0knu4-7"
})(["background:none;color:inherit;border:none;padding:0;font:inherit;cursor:pointer;outline:inherit;color:var(--dusky-grey-6-hex);font-size:12px;line-height:15.08px;display:", ";position:absolute;bottom:8px;right:28px;", ""], props => props.searchBoxFocus ? "initial" : "none", above.mobile`
// bottom:22px;
`);
const FormContainer = _styledComponents.default.div.withConfig({
  displayName: "algolia-searchbox__FormContainer",
  componentId: "sc-1n0knu4-8"
})(["position:relative;display:", ";", " ", ""], props => props.searchBoxFocus ? "initial" : "none", above.mobile`
margin:0 auto;
  // max-width:600px;
  width: ${props => props.searchBoxFocus && "600px"};
`, above.tablet`
display:initial;
`);
const AlgoliaSearch = props => {
  const {
    currentRefinement,
    refine,
    searchBoxFocus,
    setSearchBoxFocus
  } = props;
  const searchBox = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (searchBoxFocus) searchBox.current.focus();else searchBox.current.blur();
    if (!searchBoxFocus) refine("");
  }, [searchBoxFocus]);
  return /*#__PURE__*/_react.default.createElement(SearchBoxContainer, {
    searchBoxFocus: searchBoxFocus
  }, /*#__PURE__*/_react.default.createElement(FormContainer, {
    searchBoxFocus: searchBoxFocus
  }, /*#__PURE__*/_react.default.createElement(SearchBoxForm, {
    noValidate: true,
    action: "",
    role: "search",
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/_react.default.createElement(InputContainer, null, /*#__PURE__*/_react.default.createElement(SearchBoxInput, {
    searchBoxFocus: searchBoxFocus,
    placeholder: "Search for Articles",
    type: "text",
    name: "search-input",
    value: currentRefinement,
    onChange: event => refine(event.currentTarget.value),
    onClick: () => {
      setSearchBoxFocus(true);
    },
    ref: searchBox
  }), /*#__PURE__*/_react.default.createElement(ClearButton, {
    searchBoxFocus: searchBoxFocus,
    type: "button",
    className: "clear-button",
    onClick: e => {
      e.preventDefault();
      refine("");
    }
  }, "clear"), /*#__PURE__*/_react.default.createElement(SubmitButton, null, /*#__PURE__*/_react.default.createElement(_generic.default, {
    icon: "search",
    color: _utils.colors["dusky-grey-6"].hex
  }))))), props.suggestedSearchButtons && /*#__PURE__*/_react.default.createElement(SuggestedSearchButtonContainer, null, props.suggestedSearchButtons.map((button, i) => {
    return /*#__PURE__*/_react.default.createElement(SuggestedSearchButton, {
      key: `suggested-search-button-${i}`,
      onClick: () => {
        refine(button);
      }
    }, button);
  })));
};
const AlgoliaSearchBox = (0, _reactInstantsearchDom.connectSearchBox)(AlgoliaSearch);
var _default = AlgoliaSearchBox;
exports.default = _default;
AlgoliaSearch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AlgoliaSearch"
};